import { AutoMovement } from '../../../types';

export const AUTO_MOVEMENT_MODE_OPTIONS = [
    { value: 'contains', label: 'Contém' },
    { value: 'starts_with', label: 'Começa com' },
    { value: 'exact', label: 'Exato' },
] as const satisfies ReadonlyArray<{ value: AutoMovement['mode']; label: string }>;

export const WHATSAPP_CONNECTED_STATUSES = new Set(['connected', 'Conectado', 'open']);
